/* Supply2Consume Shopify theme — shared UI behaviour */

window.Theme = window.Theme || {};

Theme.escape = function (str) {
  return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
  });
};

Theme.formatMoney = function (cents, format) {
  format = format || window.themeMoneyFormat || "£{{amount}}";
  if (typeof cents === "string") cents = cents.replace(".", "");
  var value = "";
  var placeholder = /\{\{\s*(\w+)\s*\}\}/;
  var amount = (cents / 100).toFixed(2);
  var amountNoDecimals = Math.round(cents / 100).toString();
  var parts = amount.split(".");
  var amountWithComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + parts[1];

  switch (format.match(placeholder)[1]) {
    case "amount": value = amount; break;
    case "amount_no_decimals": value = amountNoDecimals; break;
    case "amount_with_comma_separator": value = amountWithComma; break;
    default: value = amount;
  }
  return format.replace(placeholder, value);
};

document.addEventListener("DOMContentLoaded", function () {

  /* Mobile nav */
  var navToggle = document.querySelector(".nav-toggle");
  var header = document.querySelector(".site-header");
  if (navToggle && header) {
    navToggle.addEventListener("click", function () {
      header.classList.toggle("nav-open");
    });
    header.querySelectorAll(".main-nav a").forEach(function (a) {
      a.addEventListener("click", function () { header.classList.remove("nav-open"); });
    });
  }

  /* Mobile filter drawer (collection page) */
  var filterBtn = document.querySelector(".mobile-filter-btn");
  var filterClose = document.querySelector("[data-filters-close]");
  if (filterBtn) filterBtn.addEventListener("click", function () { document.body.classList.add("filters-open"); });
  if (filterClose) filterClose.addEventListener("click", function () { document.body.classList.remove("filters-open"); });

  /* Tabs (product detail page) */
  document.querySelectorAll(".tab-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.closest(".tabs-nav").parentElement;
      group.querySelectorAll(".tab-btn").forEach(function (b) { b.classList.remove("active"); });
      group.querySelectorAll(".tab-panel").forEach(function (p) { p.classList.remove("active"); });
      btn.classList.add("active");
      var panel = group.querySelector('.tab-panel[data-tab="' + btn.dataset.tabTarget + '"]');
      if (panel) panel.classList.add("active");
    });
  });

  /* Generic quantity steppers */
  document.querySelectorAll(".qty-stepper").forEach(function (stepper) {
    var input = stepper.querySelector("input");
    stepper.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var val = parseInt(input.value, 10) || 1;
        val = btn.dataset.action === "inc" ? val + 1 : Math.max(1, val - 1);
        input.value = val;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* Footer year */
  document.querySelectorAll("[data-year]").forEach(function (el) { el.textContent = new Date().getFullYear(); });

  /* Cart drawer (mini-cart) */
  var drawerClose = document.getElementById("cart-drawer-close");
  var drawerOverlay = document.getElementById("cart-drawer-overlay");
  if (drawerClose) drawerClose.addEventListener("click", Theme.closeCartDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener("click", Theme.closeCartDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") Theme.closeCartDrawer(); });

  var cartLink = document.querySelector("[data-cart-icon-link]");
  if (cartLink) {
    cartLink.addEventListener("click", function (e) {
      if (window.location.pathname.indexOf("/cart") === -1) {
        e.preventDefault();
        Theme.openCartDrawer();
      }
    });
  }

  initSearchSuggest();
});

function initSearchSuggest() {
  document.querySelectorAll(".search-box").forEach(function (box) {
    var input = box.querySelector('input[type="search"]');
    if (!input) return;
    var dropdown = document.createElement("div");
    dropdown.className = "search-suggest";
    box.appendChild(dropdown);

    var debounceTimer;
    function close() { dropdown.classList.remove("open"); dropdown.innerHTML = ""; }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) { close(); return; }
      debounceTimer = setTimeout(function () {
        fetch((window.themeRoutes.searchSuggest || "/search/suggest.json") + "?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last")
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              dropdown.innerHTML = '<div class="search-suggest-empty">No products found for "' + Theme.escape(input.value) + '"</div>';
              dropdown.classList.add("open");
              return;
            }
            dropdown.innerHTML = products.map(function (p) {
              var img = p.featured_image
                ? '<img src="' + Theme.escape(p.featured_image) + '" alt="' + Theme.escape(p.title) + '">'
                : '<svg class="icon"><use href="#icon-image"></use></svg>';
              return (
                '<a class="search-suggest-item" href="' + Theme.escape(p.url) + '">' +
                  '<span class="search-suggest-thumb">' + img + '</span>' +
                  '<span class="search-suggest-info"><strong>' + Theme.escape(p.title) + '</strong><span>' + Theme.escape(p.vendor || "") + '</span></span>' +
                  '<span class="search-suggest-price">' + Theme.formatMoney(p.price) + '</span>' +
                '</a>'
              );
            }).join("") +
            '<a class="search-suggest-viewall" href="' + (window.themeRoutes.search || "/search") + '?q=' + encodeURIComponent(input.value) + '&type=product">View all results for "' + Theme.escape(input.value) + '" <svg class="icon"><use href="#icon-arrow-right"></use></svg></a>';
            dropdown.classList.add("open");
          })
          .catch(function () { close(); });
      }, 200);
    });

    input.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    document.addEventListener("click", function (e) { if (!box.contains(e.target)) close(); });
  });
}
